module.exports = __webpack_public_path__ + "img/pic_1.6cebf05f.jpg";